import React, { useEffect } from "react";
import logo from "../Assets/Logo/logo.webp";

const Apply = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.fbq) {
      window.fbq("track", "Lead");
    }

    const cssId = "orufy-widget-css";
    if (!document.getElementById(cssId)) {
      const link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = "https://orufybookings.com/external/widget.css";
      link.type = "text/css";
      link.media = "all";
      document.head.appendChild(link);
    }

    const scriptId = "orufy-widget-js";
    const initWidget = () => {
      if (window.orufyBookings && window.orufyBookings.InLineWidget) {
        window.orufyBookings.InLineWidget();
      }
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "module";
      script.src = "https://orufybookings.com/external/widget.js";
      script.onload = initWidget;
      document.body.appendChild(script);
    } else {
      initWidget();
    }
  }, []);

  return (
    <>
      <section>
        <img src={logo} alt="Social Eagle" className="applylogo" />
        <div className="container-fluid p-0">
          <div
            style={{ height: "100dvh" }}
            className="orufy-bookings-inline-widget"
            data-access-link="/social-eagle-private-limited/expert-call-with-social-eagle-digital-marketing?BackgroundColor=FFFFFF&BrandColor=098666&hideLHS=false"
          ></div>
        </div>
      </section>
    </>
  );
};

export default Apply;